import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Text_module from "./Text.module.js";
import "../../typography/fonts.css";
import { combineClasses } from "../../utilities/combineClasses.js";
import { theme } from "../../theme/index.js";
const Text = /*#__PURE__*/ forwardRef(({ as, styleAs, className, style, size: _size, color: _color, bold: _bold, ellipsis, testId, ...props }, ref)=>{
    const As = as ?? 'span';
    const variant = styleAs ?? As;
    const textStyle = tagToStyleMap[variant];
    const size = _size ?? textStyle.size;
    const color = _color ?? textStyle.color;
    const bold = _bold ?? textStyle.bold;
    return /*#__PURE__*/ jsx(As, {
        ref: ref,
        className: combineClasses(className, Text_module.text, ellipsis && Text_module.ellipsis),
        style: {
            '--text--color': theme.color[color] ?? color,
            '--text--font-size': theme.fontSize[size] ?? size,
            '--text--line-height': theme.lineHeight[size] ?? size,
            '--text--font-weight': 'boolean' == typeof bold ? theme.fontWeight[bold ? 'bold' : 'regular'] : bold,
            ...style
        },
        "data-testid": testId,
        ...props
    });
});
Text.displayName = 'Text';
const tagToStyleMap = {
    span: {
        size: '200',
        bold: false,
        color: 'gray-800'
    },
    get p () {
        return this.span;
    },
    get div () {
        return this.span;
    },
    h1: {
        size: '700',
        bold: true,
        color: 'gray-900'
    },
    h2: {
        size: '600',
        bold: true,
        color: 'gray-900'
    },
    h3: {
        size: '500',
        bold: true,
        color: 'gray-900'
    },
    h4: {
        size: '400',
        bold: true,
        color: 'gray-900'
    },
    h5: {
        size: '300',
        bold: true,
        color: 'gray-900'
    },
    h6: {
        size: '200',
        bold: true,
        color: 'gray-900'
    }
};
export { Text };
